/**
 * resourceOptimize模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const resourceOptimize = {
  // 查询ec2
  resourceOptimizationDashboard(params){
    return $http.post(`${global.API_URL}/sme/resourceOptimize/resourceOptimizationDashboard`,params);
  },
  // 查询rds
  resourceOptimizationRdsDashboard(params){
    return $http.post(`${global.API_URL}/sme/resourceOptimize/resourceOptimizationRdsDashboard`,params);
  },
  // 查询elastiCache
  resourceOptimizationElasticacheDashboard(params){
    return $http.post(`${global.API_URL}/sme/resourceOptimize/resourceOptimizationElasticacheDashboard`,params);
  },
  // 查询redShift
  resourceOptimizationRedshiftDashboard(params){
    return $http.post(`${global.API_URL}/sme/resourceOptimize/resourceOptimizationRedshiftDashboard`,params);
  },
   // 查询project值下拉框
  projectBox(params){
   return $http.post(`${global.API_URL}/sme/resourceOptimize/projectBox`,params);
 },
 // 查询Elasticsearch   
 resourceOptimizationElasticsearchDashboard(params){
   return $http.post(`${global.API_URL}/sme/resourceOptimize/resourceOptimizationElasticsearchDashboard`,params);
 },
  //导出
  exportExcel(params) {
    return $http.post(`${global.API_URL}/sme/resourceOptimize/exportExcel`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  //导出RDS
  exportRdsExcel(params) {
    return $http.post(`${global.API_URL}/sme/resourceOptimize/exportRdsExcel`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  //导出ElastiCache
  exportElasticacheExcel(params) {
    return $http.post(`${global.API_URL}/sme/resourceOptimize/exportElasticacheExcel`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  //导出RedShift
    exportRedshiftExcel(params) {
      return $http.post(`${global.API_URL}/sme/resourceOptimize/exportRedshiftExcel`, params, {
        responseType: 'arraybuffer',
        timeout: 1000 * 60 * 5
      });
    },
     //导出Elasticsearch
      exportElasticsearchExcel(params) {
        return $http.post(`${global.API_URL}/sme/resourceOptimize/exportElasticsearchExcel`, params, {
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 5
        });
      },
  //资源类型
  resourceTypeBox(params) {
    return $http.post(`${global.API_URL}/sme/resourceOptimize/resourceTypeBox`,params);
  },
  // ri
  queryRiDataSourceBox(){
    return $http.post(`${global.API_URL}/sme/resourceOptimize/queryRiDataSourceBox`);
  }
}

export default resourceOptimize;



// WEBPACK FOOTER //
// ./src/api/resourceOptimize.js